import React from 'react'
import { Link } from 'react-router-dom'

const Navbar = () => {
  return (
    <div className='nav'>
       
         <div className='navlist'> 
       <Link to="/" style={{ textDecoration: 'none'}}><li> Home </li><hr/></Link> 
       <Link to="Projects" style={{ textDecoration: 'none'}}> <li> Projects</li> <hr/></Link>
       <Link to="Experience" style={{ textDecoration: 'none'}}> <li> Experience</li><hr/></Link>
          </div>
      

    </div>
  )
}

export default Navbar